module.exports = __webpack_public_path__ + "img/left-arrow.fca728b7.svg";